<sui-dialog-simple>
  <ng-template suiDialogHeader>
    <h2 ngpDialogTitle>
      {{ "swap-widget-dialog.header.swap-widget-type" | translate }}
    </h2>
    @if (widget?.title) {
      <h2 ngpDialogDescription>{{ widget.title }}</h2>
    }

    <sui-button
      size="sm"
      variant="danger"
      shape="round"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancel()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogContent>
    <div class="swap-widget-content">
      <div class="filter-controls">
        <app-search-input
          [placeholder]="'widget-sidebar.search.placeholder' | translate"
          (inputChanged)="handleInputChange($event)"
        ></app-search-input>

        <sui-combobox
          class="group-select"
          [options]="groupOptions()"
          [ngModel]="selectedPresetGroupId"
          (ngModelChange)="onGroupChange($event)"
        ></sui-combobox>
      </div>

      <div class="preset-list">
        @if (widgetPresetsLoading$ | async) {
          <app-loading></app-loading>
        }

        @if (widgetPresetsFiltered().length > 0) {
          @for (
            widgetPreset of widgetPresetsFiltered() | sort: "display_order";
            track widgetPreset
          ) {
            <app-widget-preset-card
              [widgetPreset]="widgetPreset"
              [highlight]="searchString"
              [selectedPresetId]="selectedPresetId"
              [selectedChartTypeId]="selectedChartTypeId"
              (onWidgetPreview)="onWidgetPreview($event)"
            ></app-widget-preset-card>
          }
        } @else {
          <p class="no-presets-message">
            {{ "widget-sidebar.message.no-presets-available" | translate }}
          </p>
        }
      </div>
    </div>
  </ng-template>

  <ng-template suiDialogFooter>
    <sui-button variant="secondary" (click)="cancel()">
      {{ "btn.cancel" | translate }}
    </sui-button>

    <sui-button
      variant="primary"
      [disabled]="!selectedEvent"
      (click)="confirm()"
    >
      {{ "swap-widget-dialog.button.swap" | translate }}
    </sui-button>
  </ng-template>
</sui-dialog-simple>
